export default function convertIf(component) {
  var properties = component.properties;
  var _ref = properties,
    dataSource = _ref.dataSource;
  return {
    brick: ":if",
    dataSource: dataSource
  };
}
//# sourceMappingURL=convertIf.js.map